// initiate deployment process
import React, { Fragment } from "react";
//import { useNavigate } from 'react-router-dom';
import { Header } from "../components/Header";
import "../style/pages/auth.css";
interface MainLayoutProps {
  children: any;
  headertext?: string;
}
import Loading from "../components/questionnaires/loading/Loading";
import { clearSession } from "../utils/auth";

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [loader, setloader] = React.useState(false);

  async function logout() {
    setloader(true);
      clearSession("Logout: MainLayout", "/auth/login");
  }
  return (
    <Fragment>
      <section>
        <Header probileshow />
        <div className="logout-text">
          <button onClick={logout}>
            <a>Logout</a>
          </button>
          {/* <a onClick={() => navigate("/profile")}>Profile</a>
          <a onClick={() => navigate("/")}>Home</a> */}
        </div>
        {children}
        {loader && (
          <div>
            <div className="overlay-logout"></div>
            <div className={`popup ${loader ? "loader" : ""}`}>
              <Loading status={loader} />
            </div>
          </div>
        )}
      </section>
    </Fragment>
  );
};
